import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Chip } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  betaChip: {
    backgroundColor: theme.palette.beta.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.beta.main,
    },
    marginLeft: '10px',
  },
}));

const BetaTag = () => {
  const classes = useStyles();
  return <Chip label="beta" className={classes.betaChip} size="small" />;
};

export default BetaTag;
